import { render } from "./OrderView.vue?vue&type=template&id=776b682e"
import script from "./OrderView.vue?vue&type=script&lang=js"
export * from "./OrderView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/it60371727/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__